import toast from 'react-hot-toast'

import { useMutation } from '@fv/client-core'

import { useCacheHelpers } from '@/hooks/opportunities'
import type { Opportunity } from '@/types/Opportunity'
import { carrierFetch } from '@/utils/carrierFetch'

interface RejectOpts {
  loadId: string
}
async function rejectLoad({ loadId }: RejectOpts) {
  return await carrierFetch<Opportunity>(`/loads/${loadId}/reject`, {
    method: 'POST',
  })
}

export function useRejectLoad() {
  const { updateOppCaches, refreshBucketCounts } = useCacheHelpers()

  return useMutation(rejectLoad, {
    onSuccess: opportunity => {
      updateOppCaches(opportunity, ['awarded', 'confirmed'])
      refreshBucketCounts()

      toast.success('Load declined successfully.')
    },
  })
}
